"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_share-now.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var PREDEFINED_TAGS = [{
  icon: 'youtube',
  label: 'YouTube',
  tagValue: 'YT'
}, {
  icon: 'facebook2',
  label: 'Facebook',
  tagValue: 'FB'
}, {
  icon: 'twitter2',
  label: 'Twitter',
  tagValue: 'TW'
}];

function onChangeTagCheckbox(type, onUpdateTags, tags, tagInputRef) {
  return function () {
    var tagIndex = tagInputRef.state.tags.findIndex(function (tag) {
      return tag.value === type;
    });

    if (tagIndex === -1) {
      tagInputRef.setState({
        text: type
      }, function () {
        tagInputRef.handleKeyDown({
          keyCode: 13,
          currentTarget: {}
        });
      });
    }

    tagInputRef.deleteTag(type)();
  };
}

function ShareNow(_ref) {
  var shareTags = _ref.shareTags,
      onUpdateTags = _ref.onUpdateTags;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      tagInputRef = _useState2[0],
      setTagInput = _useState2[1];

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "share-now"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "share-now__checkboxes"
  }, PREDEFINED_TAGS.map(function (tagProps) {
    return /*#__PURE__*/_react.default.createElement(_uiKit.Checkbox, {
      key: tagProps.tagValue,
      checked: shareTags.toUpperCase().includes(tagProps.tagValue),
      onChange: tagInputRef && onChangeTagCheckbox(tagProps.tagValue, onUpdateTags, shareTags, tagInputRef),
      prefixIcon: tagProps.icon
    }, tagProps.label);
  })), /*#__PURE__*/_react.default.createElement(_uiKit.TagInput, {
    label: "Add Custom Tags",
    ref: setTagInput,
    onChange: onUpdateTags
  }));
}

var _default = /*#__PURE__*/(0, _react.memo)(ShareNow);

exports.default = _default;